module.exports = __webpack_public_path__ + "static/media/photo-4.414e3baf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/willow-walk-extension/photo-4.jpg
// module id = 170
// module chunks = 0